import {
  SET_SUPPLIER_DETAILS_RFQ,
  SET_SUPPLIER_NAME_LIST,
  SET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS,
  SET_TRANSPORTER_MAPPING_LIST
} from "Constants/actionConstants";

import {
CREATE_TRANSPORTATION_RFQ_URL,
DOWNLOAD_PROVIDER_MATERIAL_PACKING_DETAILS_URL,
GET_PROVIDER_MATERIAL_PACKING_DETAILS_URL,
GET_SUPPLIER_DETAILS_RFQ_URL,
GET_SUPPLIER_NAME_LIST_URL,
GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS_URL,
GET_TRANSPORTER_MAPPING_LIST_URL
} from "Utils/api";

import axiosT1 from "Utils/axios";
import { call, put } from "redux-saga/effects";

export function* getSupplierTransportationContractsDetails(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS_URL,
      {
        params: action.queryParams,
      }
    );
    const statusDetails = resData.data.data.status_details;
    const contractsDetailsList = resData.data.data.list;

    yield put({
      type: SET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS,
      payload: {
        statusDetails,
        contractsDetailsList,
      },
    });
  } catch (e) {
    console.log("e:", e);
  }
}


export function* getSupplierNameList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_SUPPLIER_NAME_LIST_URL,
      );

      let supplierNameList = resData.data.data || []

      supplierNameList =  supplierNameList.map((ele)=>{
         const newEle = {
          label:ele.user_name,
          value:ele.user_name
         }
         return newEle
      })

    yield put({
      type: SET_SUPPLIER_NAME_LIST,
      payload:supplierNameList
    });
  } catch (e) {
    console.log("e:", e);
  }
}


export function* createTransportationRfq(action) {
  try {
    const resData = yield call(
      axiosT1.post,
      CREATE_TRANSPORTATION_RFQ_URL,
      action.payload
      );

      if(action.onSuccess){
        action.onSuccess(resData.data.data)
      }

  } catch (e) {
    console.log("e:", e);
  }
}


export function* getSupplierDetailsRfq(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_SUPPLIER_DETAILS_RFQ_URL,
      {
        params: action.queryParams
      }
    );

    const supplierDetailsRfq = resData.data.data || {}

    yield put({
      type: SET_SUPPLIER_DETAILS_RFQ,
      payload: supplierDetailsRfq
    });
    
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getTransporterMappingList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_TRANSPORTER_MAPPING_LIST_URL,{
        params: action.queryParams
      }
      );

      let transporterMappingList = resData.data.data.list || []
      transporterMappingList =  transporterMappingList.map((ele)=>{
         const newEle = {
          ...ele,
          label:ele.name,
          value:ele.id
         }
         return newEle
      })

    yield put({
      type: SET_TRANSPORTER_MAPPING_LIST,
      payload:transporterMappingList
    });
    
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getProviderMaterialPackingDetails(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_PROVIDER_MATERIAL_PACKING_DETAILS_URL,{
        params: action.queryParams
      });
      const  link =  resData.data.data.link
      if(action.onSuccess){
        action.onSuccess(link)
      }
  } catch (e) {
    console.log("e:", e);
  }
}
